import Carousel from "react-multi-carousel";
import * as React from "react";
import { render } from "react-dom";
import { WithStyles } from "@material-ui/core/styles";

const responsive = {
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 3,
    slidesToSlide: 3, // optional, default to 1.
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 2,
    slidesToSlide: 2, // optional, default to 1.
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
    slidesToSlide: 1, // optional, default to 1.
  },
};

var musique = {
  backgroundImage:
    "url(" + require("./assets/gdc/animations/musique.jpg") + ")",
};

var danses = {
  backgroundImage: "url(" + require("./assets/gdc/animations/danses.jpg") + ")",
};

var magicien = {
  backgroundImage:
    "url(" + require("./assets/gdc/animations/magicien.jpg") + ")",
};

var ludiques = {
  backgroundImage:
    "url(" + require("./assets/gdc/animations/ballons.jpg") + ")",
};

var digitales = {
  backgroundImage:
    "url(" + require("./assets/gdc/animations/starwars.jpg") + ")",
};

var photos = {
  backgroundImage:
    "url(" + require("./assets/gdc/animations/western.jpg") + ")",
};

var interactives = {
  backgroundImage:
    "url(" + require("./assets/gdc/animations/peinture.jpg") + ")",
};

var casino = {
  backgroundImage: "url(" + require("./assets/gdc/animations/casino.jpg") + ")",
};

var divStyle = {
  backgroundImage:
    "url(" + require("./assets/gdc/lieux/22-tourelles-fonville.jpg") + ")",
};

render(
  <Carousel
    additionalTransfrom={0}
    arrows
    autoPlaySpeed={3000}
    centerMode={false}
    className=""
    containerClass="container-with-dots"
    dotListClass=""
    draggable
    focusOnSelect={false}
    infinite
    itemClass=""
    keyBoardControl
    minimumTouchDrag={80}
    renderButtonGroupOutside={false}
    renderDotsOutside={false}
    responsive={{
      desktop: {
        breakpoint: {
          max: 3000,
          min: 1024,
        },
        items: 3,
        partialVisibilityGutter: 40,
      },
      mobile: {
        breakpoint: {
          max: 464,
          min: 0,
        },
        items: 1,
        partialVisibilityGutter: 30,
      },
      tablet: {
        breakpoint: {
          max: 1024,
          min: 464,
        },
        items: 2,
        partialVisibilityGutter: 30,
      },
    }}
    showDots={false}
    sliderClass=""
    slidesToSlide={1}
    swipeable
  >
    <div className="jss4 jss7 jss5 jss3 jss1">
      <button className="jss34 jss31" type="button">
        <div
          className="jss37 jss2"
          title="Animation"
          style={musique}
        ></div>
        <div className="jss39">
          <h2 className="jss40 jss56 jss67">Animations musicales</h2>
          <p className="jss40 jss49">
            Les animations musicales sont la clé d’un événement d’entreprise ou
            d’une soirée événementielle réussie.
            <p>
              La musique est source de joie, de sourire et de bonne humeur.
            </p>{" "}
            C'est pourquoi 3D Organisation vous propose de faire danser et
            chanter vos invités en vous proposant un choix vaste parmi les
            styles afin de répondre à tous vos thèmes en matière d'animation
            musicale.
            <p>
              De l'orchestre de jazz, à la troupe médiévale, à l'orchestre
              country jusqu'au DJ, avec des prestations ou des concerts de 30
              minutes jusqu'à 3 heures nous vous garantissons une ambiance de
              grande qualité pour votre événement.
            </p>
          </p>
        </div>
        <span className="jss33"></span>
        <span className="jss126"></span>
      </button>
      <div className="jss76">
        <a target="_blank" href="./accueil.html" className="jss78">
          <button
            className="jss34 jss79 jss81 jss82 jss84 jss85 jss102"
            type="button"
          >
            <span className="jss80"><a href="./nos-animations.html#contact">Demander un devis</a></span>
            <span className="jss140"></span>
          </button>
        </a>
      </div>
    </div>

    <div className="jss4 jss7 jss5 jss3 jss1">
      <button className="jss34 jss31" type="button">
        <div
          className="jss37 jss2"
          title="Animation"
          style={danses}
        ></div>
        <div className="jss39">
          <h2 className="jss40 jss56 jss67">Animations de danse</h2>
          <p className="jss40 jss49">
            <p>
              Les animations orchestrées par nos danseurs raviront les yeux de
              vos invités avant de les initier pour ravir l'amateur jusqu'au
              professionnel.
            </p>
            <p>
              3D Organisation vous propose de faire danser vos invités tout en
              convivialité !
            </p>
            <p>
              De l'initiation à la danse country, au passage de notre duo de
              danseuses de charleston, à la déambulation de nos danseuses
              médiévales jusqu'aux interventions dansées de nos coyotes girls,
              voyagez à travers les styles et les époques.
            </p>
          </p>
        </div>
        <span className="jss33"></span>
        <span className="jss126"></span>
      </button>
      <div className="jss76">
        <a target="_blank" href="./accueil.html" className="jss78">
          <button
            className="jss34 jss79 jss81 jss82 jss84 jss85 jss102"
            type="button"
          >
            <span className="jss80"><a href="./nos-animations.html#contact">Demander un devis</a></span>
            <span className="jss140"></span>
          </button>
        </a>
      </div>
    </div>

    <div className="jss4 jss7 jss5 jss3 jss1">
      <button className="jss34 jss31" type="button">
        <div
          className="jss37 jss2"
          title="Animation"
          style={magicien}
        ></div>
        <div className="jss39">
          <h2 className="jss40 jss56 jss67">Animations artistiques</h2>
          <p className="jss40 jss49">
            <p>
              Source d'enchantement, d'émerveillement et de surprise, les
              animations artistiques sont le clou du spectacle lors de votre
              soirée événementielles.
            </p>
            <p>
              Notre offre artistique permet de révéler tout type de talent : le
              bluff du magicien grâce à la manipulation de balles, gobelets, dés
              et cartes parmi vos invités, l'impressionnant courage des
              cracheurs de feu, l'extraordinaire équilibre des échassiers,
              l'humour des comédiens, l'habilité des jongleurs traditionnels, la
              finesse et la rapidité du coup de crayon d'un caricaturiste, la
              créativité des maquilleuses mais aussi la précision des cascadeurs
              avec les fouets, les revolvers et les lassos.
            </p>
            <p>
              {" "}
              3D Organisation vous garantit des prestations de haute voltige.
            </p>
          </p>
        </div>
        <span className="jss33"></span>
        <span className="jss126"></span>
      </button>
      <div className="jss76">
        <a target="_blank" href="./accueil.html" className="jss78">
          <button
            className="jss34 jss79 jss81 jss82 jss84 jss85 jss102"
            type="button"
          >
            <span className="jss80"><a href="./nos-animations.html#contact">Demander un devis</a></span>
            <span className="jss140"></span>
          </button>
        </a>
      </div>
    </div>

    <div className="jss4 jss7 jss5 jss3 jss1">
      <button className="jss34 jss31" type="button">
        <div
          className="jss37 jss2"
          title="Animation"
          style={ludiques}
        ></div>
        <div className="jss39">
          <h2 className="jss40 jss56 jss67">Animations ludiques</h2>
          <p className="jss40 jss49">
            <p>
              Les animations ludiques sont un incontournable des événements
              d’entreprise pour faire jouer vos convives dans un moment de
              partage et de convivialité.
            </p>
            <p>
              {" "}
              Qu’ils soient dans la thématique de soirée ou en libre accès dans
              le contexte d’un cocktail dinatoire ou d’un after work, les jeux,
              stands forains et autres animations seront source de rire et de
              plaisir. Ainsi est la volonté de 3D Organisation de vous proposer
              des animations ludiques répondants au plus de thématiques
              possibles avec des petits stands de jeux (chamboule tout, jeu de
              force, lancer de chopes de "bières" au bar, jeux de bois, lancer
              de fer à cheval, lancer du chapeau, fléchettes, tir sur ballons ou
              sur cartes géantes, tir à la carabine).
            </p>
            <p>
              {" "}
              Mais qui tiendra le plus longtemps sur le taureau mécanique ? Qui
              sera le meilleur à l'indémodable baby-foot (normal ou géant) ? Qui
              sera le meilleur au flipper ? Qui aura les meilleurs souvenirs des
              anciens jeux vidéo sur le stand de rétrogaming.
            </p>
            <p>
              {" "}
              Le seul moyen de le savoir c'est de demander ces animations
              ludiques pour votre événement.
            </p>
          </p>
        </div>
        <span className="jss33"></span>
        <span className="jss126"></span>
      </button>
      <div className="jss76">
        <a target="_blank" href="./accueil.html" className="jss78">
          <button
            className="jss34 jss79 jss81 jss82 jss84 jss85 jss102"
            type="button"
          >
            <span className="jss80"><a href="./nos-animations.html#contact">Demander un devis</a></span>
            <span className="jss140"></span>
          </button>
        </a>
      </div>
    </div>

    <div className="jss4 jss7 jss5 jss3 jss1">
      <button className="jss34 jss31" type="button">
        <div
          className="jss37 jss2"
          title="Animation"
          style={photos}
        ></div>
        <div className="jss39">
          <h2 className="jss40 jss56 jss67">Animations photos</h2>
          <p className="jss40 jss49">
            <p>
              S'il y a bien un incontournable pour immortaliser votre événement
              c'est bien évidemment le stand photo.
            </p>
            <p>
              {" "}
              Vos convives repartiront immédiatement avec leur tirage photo avec
              incrustation du logo de votre société ainsi que la date de votre
              soirée.
            </p>
            <p>
              {" "}
              La seule limite au décor de votre photo ? Votre créativité ! Les
              fonds verts, les photos call et les accessoires nous permettent de
              créer tous les décors possibles en passant par un vrai décor
              western, à une photo futuriste jusqu'à l'immersion chez Gatsby le
              magnifique.
            </p>
          </p>
        </div>
        <span className="jss33"></span>
        <span className="jss126"></span>
      </button>
      <div className="jss76">
        <a target="_blank" href="./accueil.html" className="jss78">
          <button
            className="jss34 jss79 jss81 jss82 jss84 jss85 jss102"
            type="button"
          >
            <span className="jss80"><a href="./nos-animations.html#contact">Demander un devis</a></span>
            <span className="jss140"></span>
          </button>
        </a>
      </div>
    </div>

    <div className="jss4 jss7 jss5 jss3 jss1">
      <button className="jss34 jss31" type="button">
        <div
          className="jss37 jss2"
          title="Animation"
          style={interactives}
        ></div>
        <div className="jss39">
          <h2 className="jss40 jss56 jss67">Animations interactives</h2>
          <p className="jss40 jss49">
            <p>
              Le but de ces animations est de faire participer vos invités.
              Animation à thème, activité collaborative, activités créatives et
              quizz vous sont proposés par 3D Organisation. Une soirée sur le
              thème du cinéma ? Nous vous proposons un blind-test d'intro
              musicale sur les musiques de films, des extraits vidéos à
              reconnaitre et des titres de films à mimer.
            </p>
            <p>
              Une journée team-building sur le thème "les experts à…" ? Alors
              faites contribuez vos équipes à l'enquête avec une réalisation de
              portrait-robot, l'interrogation de témoins mais aussi un relevé
              d'empreintes digitales.
            </p>
            <p>
              Une soirée quizz ? Les meilleurs thèmes vous sont proposés :
              culture générale, nostalgie, sport, quizz sur votre entreprise ou
              encore musique et cinéma. Faire jouer vos invités avec des moments
              qui resteront marqués longtemps dans vos mémoires ? Alors nous
              vous proposons une soirée "ce soir tout est permis" avec tous les
              jeux cultes de la célèbre émission : ABC Song, Air band, Let's
              Dance, photomime et Mexicooooo.
            </p>
            <p>
              Ces animations interactives sont l'occasion de créer un contexte
              propice aux échanges.
            </p>
          </p>
        </div>
        <span className="jss33"></span>
        <span className="jss126"></span>
      </button>
      <div className="jss76">
        <a target="_blank" href="./accueil.html" className="jss78">
          <button
            className="jss34 jss79 jss81 jss82 jss84 jss85 jss102"
            type="button"
          >
            <span className="jss80"><a href="./nos-animations.html#contact">Demander un devis</a></span>
            <span className="jss140"></span>
          </button>
        </a>
      </div>
    </div>

    <div className="jss4 jss7 jss5 jss3 jss1">
      <button className="jss34 jss31" type="button">
        <div
          className="jss37 jss2"
          title="Animation"
          style={casino}
        ></div>
        <div className="jss39">
          <h2 className="jss40 jss56 jss67">Animations casino</h2>
          <p className="jss40 jss49">
            <p>Tables de casino et jetons sont à l'honneur ! L'animation casino est
            menée par nos comédiens costumé façon « Al Capone » qui déambuleront
            parmi vos invités pour leur présenter leurs tables de jeux
            clandestins dans un format original de jeux sur plateau ».</p>
            <p> Qu’il
            soit de hasard, de réflexion ou de précision, laissez vos invités se
            prendre au jeu !</p><p> Pour animer votre cocktail dînatoire votre dîner
            sur le thème PROHIBITION ET COTTON CLUB, l’animation casino est un
            incontournable.</p>
          </p>
        </div>
        <span className="jss33"></span>
        <span className="jss126"></span>
      </button>
      <div className="jss76">
        <a target="_blank" href="./accueil.html" className="jss78">
          <button
            className="jss34 jss79 jss81 jss82 jss84 jss85 jss102"
            type="button"
          >
            <span className="jss80"><a href="./nos-animations.html#contact">Demander un devis</a></span>
            <span className="jss140"></span>
          </button>
        </a>
      </div>
    </div>
  </Carousel>,
  document.querySelector(".cover-flow")
);
